import InfoBeneficiaryStep2FormComponent from "../../components/info-beneficiary/InfoBeneficiaryStep2FormComponent";


export default function InfoBeneficiaryStep2Bloc() {
  return (
    <div className="">
      <div className="">
        <h2 className="card-title bleu">Je souhaite ajouter mes ayants droit</h2>
        <p className="text mt-sm mb-md">Cette liste d'ayants droit est établie à partir des attestations téléchargées. Veuillez modifier les informations incorrectes ou retirer les ayants droit que vous ne souhaitez pas couvrir.</p>
        <InfoBeneficiaryStep2FormComponent />
      </div>
      <div className="mt-lg">
        <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
      </div>
    </div>
  )
}